// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React from 'react';
import {t_states} from './types';
import {pass_err_short, pass_err_stronger} from 'hola_pub_util';
import cookie from 'cookie';
import {login_process} from './utils';

const email_errors = (error_type:string, email: string,
    go_to: (type:t_states, direction?: number)=>void, cls?: string)=>
{
    const email_match = email.match(/@(.*)$/);
    switch (error_type)
    {
    case 'invalid_email': return <div className={cls}>
        Please enter a valid email address
    </div>;
    case 'domain_blacklisted': return <div className={cls}>
        Please use another email.
        We don't allow @{email_match && email_match[1] || email} email
        address
    </div>;
    case 'email_used':
    case 'email_already_used': return <div className={cls}>
        The email address is already in
        use. <a onClick={()=>go_to('login_buttons')} className="dummy">
        Click here to sign in</a>
    </div>;
    case 'bad_email':
    default: return <div className={cls}>Please use another email.</div>;
    }
};

export const get_error_description = (error_type:string,
    email: string,
    go_to: (type:t_states, direction?: number)=>void,
    get_enc_url: ()=>string,
    can_signup: boolean,
    need_plus: boolean,
    cls?: string)=>
{
    switch (error_type)
    {
    case 'email_already_used':
    case 'bad_email':
    case 'domain_blacklisted':
    case 'invalid_email': return email_errors(error_type, email, go_to, cls);
    case 'empty_password': return <div className={cls}>Please enter a
      password</div>;
    case 'short_password': return <div className={cls}>{pass_err_short}</div>;
    case 'weak_password': return <div className={cls}>
      {pass_err_stronger}
    </div>;
    case 'change_password': return <div className={cls}><a
      onClick={()=>go_to('reset_password')}>Password must be
      changed</a></div>;
    case 'account_blocked': return <div className={cls}>Your account is
      temporarily blocked. Try
      again later or click <a onClick={()=>go_to('reset_password')}
      className="dummy">Forgot password</a> to reset it.</div>;
    case 'wrong_password': return <div className={cls}>Login failed invalid
      email/password</div>;
    case 'not_registered': return <div className={cls}>The email address is
      not registered. If you
      signed up with Google signup button, you should login with Google
      login button. {can_signup &&
      <a onClick={()=>go_to('signup_buttons')} className="dummy">
      Click here to sign up</a>}</div>;
    case 'friendly_signup': return <div className={cls}>Check your mailbox and
      follow the instructions to complete the registration process. <a
      onClick={()=>go_to('resend_premium_verification')} className="dummy">
      Resend email</a></div>;
    case 'recaptcha': return <div className={cls}>
      Please, fill captcha field correctly.
    </div>;
    case 'load_recaptcha': return <div className={cls}>
      We detect network issue from your side.
      Please reload the page and try again. <a href='#'
        onClick={()=>{ location.reload(); }}>Or click here for reload</a>
    </div>;
    case 'abuse_ip': return <div className={cls}>
      Your IP was blocked due to suspicious activity. Please sign in
      with <a onClick={()=>login_process.social_click('google',
        get_enc_url())}> Google</a> or <a
          onClick={()=>login_process.social_click('facebook',
          get_enc_url())}>Facebook</a> or contact
          us at <a href="mailto:abuse@hola.org">abuse@hola.org</a>
    </div>;
    case 'unknown': return (
        <div className={cls}>We've encountered an error.
          Please try again later.</div>
    );
    case '/':
    }
    if (need_plus)
    {
        let user = cookie.getJSON('user');
        if (user && user._id && !user.is_member)
        {
            return <div>No PLUS subscription.
            <a target="_blank"
            href="/premium?ref=login">Subscribe</a> now!</div>;
        }
    }
};
